import Vue from "vue";
import Router from "vue-router";
import store from "./store/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/",
          name: "home",
          component: () => import("./views/Home.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "/account",
          name: "account",
          component: () => import("./views/Account.vue"),
          meta: { requiresAuth: true },
        },
        {
          path: "/admin",
          name: "Admin",
          component: () => import("./views/Admin.vue"),
        },
        {
          path: "/second",
          name: "compCard",
          component: () => import("./views/Second.vue"),
        },
        {
          path: "/detail",
          name: "Detail",
          component: () => import("./views/Detail.vue"),
        },
        {
          path: "/third",
          name: "Booking",
          component: () => import("./views/Third.vue"),
        },
        {
          path: "/fourth",
          name: "Reciept",
          component: () => import("./views/Fourth.vue"),
        },
        {
          path: "/fourth_2",
          name: "Pay Out",
          component: () => import("./views/Fourth_2.vue"),
        },
        {
          path: "/fifth",
          name: "Chatbox",
          component: () => import("./views/Fifth.vue"),
        },
        {
          path: "/content",
          name: "Content",
          component: () => import("./views/Content.vue"),
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/pages/login",
          name: "page-login",
          component: () => import("@/views/pages/Login.vue"),
        },
        {
          path: "/pages/logout",
          name: "page-logout",
          component: () => import("@/views/pages/Logout.vue"),
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue"),
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404",
    },
  ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});
router.beforeEach(async (to, from, next) => {
  checkDomain();
  if (!store.getters.isAuth && localStorage.getItem("token")) {
    store.dispatch("checkUser");
  }
  if (to.meta.requiresAuth && !store.getters.isAuth) {
    next({ name: "page-login" });
  } else {
    next();
  }
  next();
});

const checkDomain = () => {
  if (
    window.location.hostname == "dev-admin-verscan.web.app" ||
    window.location.hostname == "dev-admin-verscan.firebaseapp.com"
  ) {
    window.location.replace("https://dev-admin.verscan.com/");
  }
  if (
    window.location.hostname == "uat-admin-verscan.web.app" ||
    window.location.hostname == "uat-admin-verscan.firebaseapp.com"
  ) {
    window.location.replace("https://uat-admin.verscan.com/");
  }
  if (
    window.location.hostname == "admin-verscan.web.app" ||
    window.location.hostname == "admin-verscan.firebaseapp.com"
  ) {
    window.location.replace("https://admin.verscan.com/");
  }
};

export default router;
